export class InvalidUsernamePassword extends Error {
    constructor(message?: string) {
        super(message || 'Invalid username or password');
    }
}

export class UserNotFound extends Error {
    constructor(message?: string) {
        super(message || 'User not found');
    }
}
